import React, { useEffect } from 'react';
import './UIFormMessage.scss';

export interface UIFormMessageProps {
  /**
   * Тип повідомлення (успіх або помилка)
   */
  type: 'success' | 'error';
  /**
   * Текст повідомлення
   */
  message: string;
  /**
   * Додатковий CSS клас
   */
  className?: string;
  /**
   * Час в мілісекундах, після якого повідомлення зникне (за замовчуванням 5000 мс)
   */
  timeout?: number;
  /**
   * Обробник, що викликається, коли повідомлення має зникнути
   */
  onClose: () => void;
}

const baseClass = 'UIFormMessage';

const UIFormMessage: React.FC<UIFormMessageProps> = ({
  type,
  message,
  className = '',
  timeout = 5000,
  onClose,
}) => {
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        onClose();
      }, timeout);

      return () => {
        clearTimeout(timer);
      };
    }
  }, [message, timeout, onClose]);

  if (!message) {
    return null;
  }

  const messageClasses = [
    baseClass,
    `${baseClass}--${type}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={messageClasses}>
      {message}
    </div>
  );
};

export default UIFormMessage;
